'use client'

import { BillingPreferences } from '@/features/subscription/billing/billing-preferences'

export const BillingInvoicesTab = () => {
    return <BillingPreferences />
}
